import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE, withCredentials: true });

export const SITE_URL = process.env.REACT_APP_SITE_URL;
